module.exports = __webpack_public_path__ + "assets/img/nv_bgi_right.199bd63f.png";